import {handleGqlResponseBody} from '@/utils/apollo.util';
import {EXPORT_PRODUCTS_CATALOG_QUERY, GET_PRODUCT_LIGHT_QUERY, GET_PRODUCT_PAGINATED_QUERY} from '@/graphql/store/product/product.query';
import {GET_PRODUCT_REVIEW_PAGINATED_QUERY} from '@/graphql/store/product/review/review.query';
import {GET_PRODUCT_REVIEW_REPLY_PAGINATED_QUERY} from '@/graphql/store/product/review/reply.query';
import {GET_BANNER_PAGINATED_QUERY} from '@/graphql/store/banner/banner.query';
import {GET_ARRIVAL_LIGHT_PAGINATED_QUERY, GET_ARRIVAL_PAGINATED_QUERY, GET_ARRIVAL_VIEW_PAGINATED_QUERY, GET_ARRIVAL_HISTORY_PAGINATED_QUERY} from '@/graphql/store/arrival/arrival.query';
import {GET_ARRIVAL_PRODUCT_MARKUP_PAGINATED_QUERY} from '@/graphql/store/arrival-product-markup/markup.query';

const product = {
	actions: {
		async getArrivalsViewPaginatedQuery({commit}, {skip, take, orderBy, query, branchId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ARRIVAL_VIEW_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						branchId,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getArrivalsPaginatedQuery({commit}, {skip, take, orderBy, query, activeStatus, status, branchId, productId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ARRIVAL_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						activeStatus,
						status,
						branchId,
						productId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getArrivalsLightPaginatedQuery({commit}, {skip, take, orderBy, branchId, productId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ARRIVAL_LIGHT_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						branchId,
						productId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getArrivalProductMarkupsPaginatedQuery({commit}, {skip, take, orderBy, query, individual}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ARRIVAL_PRODUCT_MARKUP_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						individual,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductsPaginatedQuery({commit}, {skip, take, orderBy, search, productIds, showInShop, currency, showInMiniCatalog}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						search,
						productIds,
						showInShop,
						currency,
						showInMiniCatalog
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async exportProductsCatalogQuery() {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: EXPORT_PRODUCTS_CATALOG_QUERY,
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductLightQuery({ commit }, { id }) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_LIGHT_QUERY,
					variables: {
						id
					},
					fetchPolicy: 'no-cache',
				});
			});
		},
		async getProductReviewsPaginatedQuery({commit}, {skip, take, orderBy, query}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_REVIEW_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductReviewRepliesPaginatedQuery({commit}, {skip, take, orderBy, reviewId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_REVIEW_REPLY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						reviewId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getBannerPaginatedQuery({ commit }, { skip, take, orderBy }) {
			return await handleGqlResponseBody(({ query }) => {
				return query({
					query: GET_BANNER_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy
					},
					fetchPolicy: 'no-cache',
				});
			});
		},
		async getArrivalsHistoryPaginatedQuery({commit}, {skip, take, orderBy, query, fromDate, toDate, action}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ARRIVAL_HISTORY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						fromDate,
						toDate,
						action
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
	}
};

export default product;
